import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import '../assets/styles/Header.css';

// const WHATSAPP_URL = 'https://wa.me/5562981368378';

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const toggleMenu = () => setMenuOpen(v => !v);
  const closeMenu = () => setMenuOpen(false);
  const handleFaqClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    closeMenu();
    navigate('/#faq');
    window.setTimeout(() => document.getElementById('faq')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 120);
  };

  return (
    <header className="header">
      <div className="container header-shell">
        <div className="logo-container">
          <Link to="/" aria-label="Início">
            {/* <img src={Logo} alt="Mundo Automação Energia Solar" className="logo" /> */}
          </Link>
        </div>

        <button className="mobile-menu-btn" onClick={toggleMenu} aria-expanded={menuOpen} aria-controls="menu-principal" aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'}>
          <span className={`menu-icon ${menuOpen ? 'active' : ''}`}><i /><i /></span>
        </button>

        <nav id="menu-principal" className={`main-nav ${menuOpen ? 'active' : ''}`} aria-label="Menu principal">
          <ul className="nav-list">
            <li><NavLink to="/" onClick={closeMenu}>Início</NavLink></li>
            <li><NavLink to="/quem-somos" onClick={closeMenu}>Sobre Nós</NavLink></li>
            <li><NavLink to="/produtos" onClick={closeMenu}>Produtos</NavLink></li>
            <li><a href="/#faq" onClick={handleFaqClick}>FAQ</a></li>
            {/* <li><NavLink to="/contato" onClick={closeMenu}>Contato</NavLink></li> */}
            {/* <li><NavLink to="/vantagens" onClick={closeMenu}>Vantagens</NavLink></li> */}
            {/* <li><NavLink to="/outros-servicos" onClick={closeMenu}>Outros Serviços</NavLink></li> */}

            {/* <li className="whatsapp-menu-item">
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-link"
                onClick={closeMenu}
              >
                <svg width="22" height="22" viewBox="0 0 32 32" className="whatsapp-icon" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.003 3C9.373 3 4 8.373 4 15.003c0 2.43.675 4.662 1.843 6.574L4 29l7.684-1.992a13.001 13.001 0 004.319.726C22.632 27.003 28 21.631 28 15.003 28.003 8.373 22.633 3 16.003 3zm0 22.973c-1.445 0-2.87-.382-4.104-1.09l-.292-.165-4.627 1.2 1.234-4.512-.19-.311A10.012 10.012 0 016.003 15c0-5.523 4.478-10 10-10 5.523 0 10 4.477 10 10-.003 5.522-4.48 9.999-10 9.999zm5.766-7.531c-.311-.155-1.845-.911-2.132-1.014-.286-.105-.493-.155-.701.155-.208.308-.8 1.012-.981 1.22-.181.207-.361.234-.673.078-1.848-.91-3.058-1.624-4.27-3.586-.322-.555.322-.516.915-1.715.102-.208.051-.388-.026-.543-.077-.155-.701-1.688-.959-2.316-.252-.606-.51-.523-.701-.532l-.601-.011c-.207 0-.543.077-.827.38-.283.307-1.078 1.054-1.078 2.57 0 1.517 1.104 2.983 1.259 3.193.155.207 2.175 3.326 5.277 4.534.739.318 1.315.506 1.764.648.741.236 1.416.203 1.948.123.594-.088 1.844-.753 2.131-.841.287-.088.494-.166.739.132.245.297.915 1.011 1.226 1.167.311.155 1.82.938 2.131 1.042.311.104.519.155.726-.155z"/>
                </svg>
                Solicitar Orçamento
              </a>
            </li> */}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
